import { render, staticRenderFns } from "./ContactInputSearchV2.vue?vue&type=template&id=7054ad50&scoped=true&"
import script from "./ContactInputSearchV2.vue?vue&type=script&lang=js&"
export * from "./ContactInputSearchV2.vue?vue&type=script&lang=js&"
import style0 from "./ContactInputSearchV2.vue?vue&type=style&index=0&id=7054ad50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7054ad50",
  null
  
)

export default component.exports